import React from 'react';
import _ from 'lodash';
import {
  AlignCenterColumn,
  AlignTextRight,
  Column,
} from 'spw-shared/globalComponents/grid';
import {
  getWorkSeatsMix,
  isSeatsAssignmentComplete,
  numberWithCommas,
} from 'spw-shared/utils';
import GreenSeatCheck from 'spw-static/images/green-seat-check.svg';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import {
  GridColumn,
  GridRow,
} from 'spw-programming-projects/building-details/worksheet/styles';
import { WorkseatSubtotalTooltip } from './workseat-subtotal-tooltip';

interface WorkSeatSubTotalRowProps {
  worksheetWorkSeats: number;
  totalWorkSeats: number;
  showDecimals: boolean;
  isDownload?: boolean;
}

const WorkSeatSubTotalRow: React.FC<WorkSeatSubTotalRowProps> = ({
  worksheetWorkSeats,
  totalWorkSeats,
  showDecimals,
  isDownload,
}: WorkSeatSubTotalRowProps) => {
  let totalWorkSeatsRemaining = totalWorkSeats - worksheetWorkSeats;
  if (
    _.isNaN(totalWorkSeatsRemaining) ||
    !_.isFinite(totalWorkSeatsRemaining)
  ) {
    totalWorkSeatsRemaining = 0;
  }

  const mixPercentageValue: string | number | JSX.Element =
    getWorkSeatsMix(totalWorkSeats, worksheetWorkSeats, { showDecimals }) ||
    NO_DATA_TO_SHOW;

  let mixPercentage = (
    <Column>
      <AlignTextRight style={{ paddingRight: '8px' }}>
        {mixPercentageValue}
      </AlignTextRight>
      <span className="smaller nowrap">% Mix should</span>
      <span className="smaller nowrap">equal 100%</span>
    </Column>
  );
  const seatAssignationComplete = isSeatsAssignmentComplete(
    totalWorkSeats,
    worksheetWorkSeats
  );
  if (seatAssignationComplete) {
    mixPercentage = (
      <AlignCenterColumn>
        <img
          src={GreenSeatCheck}
          height={18}
          width="auto"
          alt="complete mix percentage"
        />
      </AlignCenterColumn>
    );
  }
  return (
    <GridRow className="header tall">
      <GridColumn xs={3}>
        {!isDownload && <WorkseatSubtotalTooltip />}
      </GridColumn>
      <GridColumn
        xs={1}
        data-testid="seat_assignation_status"
        className={`lighter small ${
          seatAssignationComplete ? 'complete' : 'incomplete'
        } ${seatAssignationComplete ? '' : 'error'} ${
          seatAssignationComplete ? 'justifyCenter' : ''
        }`}
      >
        {mixPercentage}
      </GridColumn>
      <GridColumn xs={1} />
      <GridColumn xs={1} />
      {seatAssignationComplete ? (
        <GridColumn xs={1} />
      ) : (
        <GridColumn
          xs={1}
          className="lighter small"
          data-testid="seat_assignation_diff"
        >
          <Column>
            <span>
              <AlignTextRight>
                {numberWithCommas(totalWorkSeatsRemaining, showDecimals)}
              </AlignTextRight>
            </span>
            <span className="smaller">Work Seats Remaining</span>
          </Column>
        </GridColumn>
      )}

      <GridColumn xs={2} className="seat-percent-column" />
      <GridColumn xs={1} />
      <GridColumn xs={1} />
      <GridColumn xs={1} />
      <GridColumn xs={1} />
    </GridRow>
  );
};

export default WorkSeatSubTotalRow;
